/** Structure for the public FAQ page — keys resolved via LanguageContext. */

export interface FaqItem {
  qKey: string;
  aKey: string;
}

export interface FaqSection {
  id: string;
  titleKey: string;
  introKey: string;
  items: FaqItem[];
}

export const MARKETING_FAQ_SECTIONS: FaqSection[] = [
  {
    id: 'audience',
    titleKey: 'marketing.faqPage.section.audience.title',
    introKey: 'marketing.faqPage.section.audience.intro',
    items: [
      { qKey: 'marketing.faqPage.audience.q1', aKey: 'marketing.faqPage.audience.a1' },
      { qKey: 'marketing.faqPage.audience.q2', aKey: 'marketing.faqPage.audience.a2' },
    ],
  },
  {
    id: 'human-ai',
    titleKey: 'marketing.faqPage.section.humanAi.title',
    introKey: 'marketing.faqPage.section.humanAi.intro',
    items: [
      { qKey: 'marketing.faqPage.humanAi.q1', aKey: 'marketing.faqPage.humanAi.a1' },
      { qKey: 'marketing.faqPage.humanAi.q2', aKey: 'marketing.faqPage.humanAi.a2' },
      { qKey: 'marketing.faqPage.humanAi.q3', aKey: 'marketing.faqPage.humanAi.a3' },
    ],
  },
  {
    id: 'journey',
    titleKey: 'marketing.faqPage.section.journey.title',
    introKey: 'marketing.faqPage.section.journey.intro',
    items: [
      { qKey: 'marketing.faqPage.journey.q1', aKey: 'marketing.faqPage.journey.a1' },
      { qKey: 'marketing.faqPage.journey.q2', aKey: 'marketing.faqPage.journey.a2' },
      { qKey: 'marketing.faqPage.journey.q3', aKey: 'marketing.faqPage.journey.a3' },
      { qKey: 'marketing.faqPage.journey.q4', aKey: 'marketing.faqPage.journey.a4' },
      { qKey: 'marketing.faqPage.journey.q5', aKey: 'marketing.faqPage.journey.a5' },
      { qKey: 'marketing.faqPage.journey.q6', aKey: 'marketing.faqPage.journey.a6' },
      { qKey: 'marketing.faqPage.journey.q7', aKey: 'marketing.faqPage.journey.a7' },
    ],
  },
  {
    id: 'plans',
    titleKey: 'marketing.faqPage.section.plans.title',
    introKey: 'marketing.faqPage.section.plans.intro',
    items: [
      { qKey: 'marketing.faqPage.plans.q1', aKey: 'marketing.faqPage.plans.a1' },
      { qKey: 'marketing.faqPage.plans.q2', aKey: 'marketing.faqPage.plans.a2' },
      { qKey: 'marketing.faqPage.plans.q3', aKey: 'marketing.faqPage.plans.a3' },
      { qKey: 'marketing.faqPage.plans.q4', aKey: 'marketing.faqPage.plans.a4' },
    ],
  },
  {
    id: 'agency',
    titleKey: 'marketing.faqPage.section.agency.title',
    introKey: 'marketing.faqPage.section.agency.intro',
    items: [
      { qKey: 'marketing.faqPage.agency.q1', aKey: 'marketing.faqPage.agency.a1' },
      { qKey: 'marketing.faqPage.agency.q2', aKey: 'marketing.faqPage.agency.a2' },
    ],
  },
  {
    id: 'trust',
    titleKey: 'marketing.faqPage.section.trust.title',
    introKey: 'marketing.faqPage.section.trust.intro',
    items: [
      { qKey: 'marketing.faqPage.trust.q1', aKey: 'marketing.faqPage.trust.a1' },
      { qKey: 'marketing.faqPage.trust.q2', aKey: 'marketing.faqPage.trust.a2' },
    ],
  },
];
